import { memo } from 'react';
import { AIPromptInputV2 } from './AIPromptInput/AIPromptInputV2';
import type { AIPromptInputProps } from './AIPromptInput/types';

export const AIPromptInput = memo((props: AIPromptInputProps) => (
	<AIPromptInputV2 {...props} />
));
